import Vue from 'vue'
import highlight from './highlight'
import shortenDescription from './shortenDescription'
import formatDuration from './formatDuration'

Vue.filter('highlight', highlight)
Vue.filter('shortenDescription', shortenDescription)
Vue.filter('formatDuration', formatDuration)